module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper weex-ct weex-div",
    style: (_vm._px2rem(_vm.wrapperStyleComp, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.hasDot === true && _vm.size !== 'min') ? _c('div', {
    staticClass: "dot-triangle weex-ct weex-div",
    style: ({
      backgroundColor: _vm.iconColor
    }),
    attrs: {
      "weex-type": "div"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-wrapper weex-ct weex-div",
    style: (_vm._px2rem(_vm.btnWrapperStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "btn weex-ct weex-div",
    style: (_vm._px2rem(_vm.btnSizeComp, 75)),
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.btnClickedHandler($event)
      }
    }
  }, [(_vm.imgUrl) ? _c('div', {
    staticClass: "btn-img-container weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('figure', {
    staticClass: "btn-img weex-el weex-image",
    style: (_vm._px2rem(_vm.btnImgSizeComp, 75)),
    attrs: {
      "src": _vm.imgUrl,
      "data-img-src": _vm.imgUrl,
      "weex-type": "image"
    }
  })]) : _c('p', {
    staticClass: "btn-text weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm.textColorComp, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.text))])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-be3f606c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be3f606c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-circle-button/index.vue
// module id = 655
// module chunks = 0 1